import { homebarSideNavigationResource } from '@townsquare/home-layout/resources';
import Loadable from '@townsquare/loadable';
import { searchRoute } from '@townsquare/routes/search';
import { goalsAppGlobalSearchRoute } from '@townsquare/routes/search-goals-app';
import { projectsAppGlobalSearchRoute } from '@townsquare/routes/search-projects-app';
import { teamsAppGlobalSearchRoute } from '@townsquare/routes/search-teams-app';

const SearchView = Loadable({
	loader: () => import(/* webpackChunkName: "search-view" */ './SearchView'),
	loading: () => null,
});

searchRoute.component = SearchView;
searchRoute.resources = [homebarSideNavigationResource];
export const searchRouterRoute = searchRoute;

teamsAppGlobalSearchRoute.component = SearchView;
teamsAppGlobalSearchRoute.resources = [homebarSideNavigationResource];
export const teamsAppGlobalSearchRouterRoute = teamsAppGlobalSearchRoute;

goalsAppGlobalSearchRoute.component = SearchView;
goalsAppGlobalSearchRoute.resources = [homebarSideNavigationResource];
export const goalsAppGlobalSearchRouterRoute = goalsAppGlobalSearchRoute;

projectsAppGlobalSearchRoute.component = SearchView;
projectsAppGlobalSearchRoute.resources = [homebarSideNavigationResource];
export const projectsAppGlobalSearchRouterRoute = projectsAppGlobalSearchRoute;
